import {
  CreateUpdateSalesInvoiceOrderNumberDto,
  CreateUpdateSalesInvoiceOrderNumberDtoFromJSON,
  DefaultApi,
  GetSalesInvoiceOrderNumberDto,
} from '../autogenerated/pokApiClient';
import { SalesInvoiceOrderNumberSchema } from '../validation/schemas';
import {
  validateAgainst,
  ValidationResult,
} from '../validation/validateAgainst';

export interface SalesInvoiceOrderNumberContextInterface {
  getBySalesInvoice: (
    salesInvoiceId: string,
  ) => Promise<GetSalesInvoiceOrderNumberDto[]>;
}

export const SalesInvoiceOrderNumberContext = (
  api: DefaultApi,
): SalesInvoiceOrderNumberContextInterface => ({
  getBySalesInvoice: (salesInvoiceId: string) =>
    api.salesInvoiceOrderNumberControllerGetBySalesInvoice(salesInvoiceId),
});

export const validate = (
  dto: CreateUpdateSalesInvoiceOrderNumberDto,
): Promise<ValidationResult> =>
  validateAgainst(SalesInvoiceOrderNumberSchema, dto);

export const newOrderNumber = (): CreateUpdateSalesInvoiceOrderNumberDto =>
  CreateUpdateSalesInvoiceOrderNumberDtoFromJSON({});

export const convert = (
  item?: GetSalesInvoiceOrderNumberDto,
): CreateUpdateSalesInvoiceOrderNumberDto =>
  item
    ? CreateUpdateSalesInvoiceOrderNumberDtoFromJSON(item)
    : newOrderNumber();
